const lt = {
  // ============================================================
  // COMMON — Shared across the entire application
  // ============================================================
  common: {
    loading: 'Kraunama...',
    error: 'Klaida',
    save: 'Išsaugoti',
    cancel: 'Atšaukti',
    delete: 'Ištrinti',
    edit: 'Redaguoti',
    create: 'Sukurti',
    add: 'Pridėti',
    remove: 'Pašalinti',
    close: 'Uždaryti',
    confirm: 'Patvirtinti',
    apply: 'Taikyti',
    reset: 'Atstatyti',
    search: 'Ieškoti',
    filter: 'Filtruoti',
    clear: 'Valyti',
    back: 'Atgal',
    next: 'Kitas',
    previous: 'Ankstesnis',
    submit: 'Pateikti',
    update: 'Atnaujinti',
    refresh: 'Atnaujinti',
    export: 'Eksportuoti',
    import: 'Importuoti',
    download: 'Atsisiųsti',
    upload: 'Įkelti',
    print: 'Spausdinti',
    copy: 'Kopijuoti',
    yes: 'Taip',
    no: 'Ne',
    ok: 'Gerai',
    done: 'Atlikta',
    select: 'Pasirinkti',
    selectAll: 'Pasirinkti viską',
    deselectAll: 'Atžymėti viską',
    noResults: 'Rezultatų nerasta',
    noData: 'Duomenų nėra',
    required: 'Privaloma',
    optional: 'Neprivaloma',
    actions: 'Veiksmai',
    details: 'Išsamiau',
    overview: 'Apžvalga',
    summary: 'Santrauka',
    total: 'Iš viso',
    all: 'Visi',
    none: 'Nėra',
    name: 'Pavadinimas',
    type: 'Tipas',
    status: 'Būsena',
    date: 'Data',
    time: 'Laikas',
    description: 'Aprašymas',
    notes: 'Pastabos',
    comments: 'Komentarai',
    category: 'Kategorija',
    priority: 'Prioritetas',
    nation: 'Šalis',
    country: 'Valstybė',
    email: 'El. paštas',
    phone: 'Telefonas',
    address: 'Adresas',
    location: 'Vieta',
    coordinates: 'Koordinatės',
    latitude: 'Platuma',
    longitude: 'Ilguma',
    from: 'Nuo',
    to: 'Iki',
    createdAt: 'Sukurta',
    updatedAt: 'Atnaujinta',
    createdBy: 'Sukūrė',
    modifiedBy: 'Pakeitė',
    active: 'Aktyvus',
    inactive: 'Neaktyvus',
    enabled: 'Įjungta',
    disabled: 'Išjungta',
    showing: 'Rodoma',
    of: 'iš',
    page: 'Puslapis',
    perPage: 'puslapyje',
    rows: 'eilutės',
    items: 'elementai',
    results: 'rezultatai',
    sortBy: 'Rūšiuoti pagal',
    ascending: 'Didėjančia tvarka',
    descending: 'Mažėjančia tvarka',
    viewAll: 'Peržiūrėti viską',
    viewDetails: 'Peržiūrėti išsamiau',
    goBack: 'Grįžti atgal',
    learnMore: 'Sužinoti daugiau',
    seeMore: 'Žiūrėti daugiau',
    showMore: 'Rodyti daugiau',
    showLess: 'Rodyti mažiau',
    expandAll: 'Išskleisti viską',
    collapseAll: 'Sutraukti viską',
    copied: 'Nukopijuota!',
    saved: 'Išsaugota!',
    deleted: 'Ištrinta!',
    updated: 'Atnaujinta!',
    created: 'Sukurta!',
    success: 'Sėkmė',
    warning: 'Įspėjimas',
    info: 'Informacija',
    danger: 'Pavojus',
    unknown: 'Nežinoma',
    notAvailable: 'Nėra',
    never: 'Niekada',
    today: 'Šiandien',
    yesterday: 'Vakar',
    tomorrow: 'Rytoj',
    now: 'Dabar',
    ago: 'prieš',
    justNow: 'ką tik',
    minutesAgo: 'prieš {{count}} min.',
    hoursAgo: 'prieš {{count}} val.',
    daysAgo: 'prieš {{count}} d.',
    monthsAgo: 'prieš {{count}} mėn.',
    id: 'ID',
    version: 'Versija',
    language: 'Kalba',
    theme: 'Tema',
    darkMode: 'Tamsi tema',
    lightMode: 'Šviesi tema',
    failedToLoad: 'Nepavyko įkelti duomenų',
    failedToSave: 'Nepavyko išsaugoti',
    failedToDelete: 'Nepavyko ištrinti',
    failedToUpdate: 'Nepavyko atnaujinti',
    confirmDelete: 'Ar tikrai norite tai ištrinti?',
    confirmAction: 'Ar esate tikri?',
    unsavedChanges: 'Turite neišsaugotų pakeitimų. Ar tikrai norite išeiti?',
    pageNotFound: '404 – Puslapis nerastas',
    pageNotFoundDesc: 'Puslapis, kurio ieškote, neegzistuoja.',
    backToDashboard: 'Grįžti į valdymo skydelį',
    characters: 'simboliai',
    maxCharacters: 'Daugiausiai {{max}} simbolių',
    remaining: 'Liko {{count}}',
    selected: 'Pasirinkta {{count}}',
    of_total: '{{count}} iš {{total}}',
    utcHint: 'All times are in UTC',
    utcStoredHint: 'Times are stored in UTC in the database',
  },

  // ============================================================
  // NAVIGATION — Header, sidebar, menus
  // ============================================================
  nav: {
    dashboard: 'Valdymo skydelis',
    requests: 'Užklausos',
    transports: 'Transportai',
    myPatients: 'Mano pacientai',
    statistics: 'Statistika',
    flow: 'Srautas',
    resources: 'Resources',
    exercise: 'Pratybos',
    administration: 'Administravimas',
    map: 'Žemėlapis',
    info: 'Informacija',
    users: 'Naudotojai',
    assets: 'Ištekliai',
    hubs: 'Mazgai',
    treatmentFacilities: 'Gydymo įstaigos',
    patientImport: 'Pacientų importas',
    assetTemplates: 'Išteklių šablonai',
    dayTemplates: 'Dienos šablonai',
    announcementTicker: 'Pranešimų juosta',
    exerciseStatistics: 'Pratybų statistika',
    settings: 'Nustatymai',
    auditLog: 'Audito žurnalas',
    exerciseControl: 'Pratybų valdymas',
    dataSync: 'Duomenų sinchronizavimas',
    documentation: 'Dokumentacija',
    support: 'Pagalba',
    about: 'Apie',
    assetContracts: 'Asset Contracts',
    notifications: 'Pranešimai',
    schedules: 'Tvarkaraščiai',
    capacityPlanning: 'Pajėgumų planavimas',
    transportPlanning: 'Transporto planavimas',
    transportBooking: 'Transporto rezervacija',
    flowDiagram: 'Srauto diagrama',
    changePassword: 'Keisti slaptažodį',
    missions: 'Misijos',
    startPoints: 'Pradžios taškai',
    hospital: 'Ligoninė',
  },

  // ============================================================
  // AUTH — Login, password, session
  // ============================================================
  auth: {
    login: 'Prisijungti',
    logout: 'Atsijungti',
    logoutNow: 'Atsijungti dabar',
    loggingIn: 'Jungiamasi...',
    loginFailed: 'Prisijungimas nepavyko',
    email: 'El. paštas',
    password: 'Slaptažodis',
    username: 'Naudotojo vardas',
    enterEmail: 'Įveskite savo el. pašto adresą',
    enterPassword: 'Įveskite savo slaptažodį',
    enterUsername: 'Įveskite savo naudotojo vardą',
    forgotPassword: 'Pamiršote slaptažodį?',
    forgotPasswordTitle: 'Pamirštas slaptažodis',
    forgotPasswordDesc: 'Įveskite savo naudotojo vardą ir el. pašto adresą. Jei abu sutampa, administratoriai bus informuoti apie slaptažodžio atstatymą.',
    requestPasswordReset: 'Prašyti slaptažodžio atstatymo',
    sending: 'Siunčiama...',
    backToLogin: 'Grįžti prie prisijungimo',
    pleaseWait: 'Palaukite prieš bandydami dar kartą.',
    requestFailed: 'Užklausa nepavyko',
    credentialsMatch: 'Jei prisijungimo duomenys sutampa, administratoriai buvo informuoti.',
    forAccess: 'Norėdami gauti prieigą, susisiekite su sistemos administratoriumi.',
    changePassword: 'Keisti slaptažodį',
    currentPassword: 'Dabartinis slaptažodis',
    newPassword: 'Naujas slaptažodis',
    confirmPassword: 'Patvirtinti slaptažodį',
    passwordChanged: 'Slaptažodis sėkmingai pakeistas',
    passwordMismatch: 'Slaptažodžiai nesutampa',
    passwordTooShort: 'Slaptažodis turi būti bent 8 simbolių',
    changingPassword: 'Keičiama...',
    mustChangePassword: 'Prieš tęsdami turite pakeisti slaptažodį.',
    sessionExpiring: 'Sesija baigiasi',
    sessionExpireText: 'Jūsų sesija baigsis po <strong>{{time}}</strong>. Išsaugokite savo darbą ir prisijunkite iš naujo, kad galėtumėte tęsti.',
    dismiss: 'Atmesti',
    switchNation: 'Pakeisti šalį',
    returnTo: 'Grįžti į {{nation}}',
    viewingAs: 'Žiūrite kaip',
    loggedInAs: 'prisijungę kaip {{nation}}',
    trainingMode: 'TIK MOKYMO TIKSLAIS',
    dedication: 'Sukurta su meile ir atsidavimu profesijai',
  },

  // ============================================================
  // ROLES — User roles and labels
  // ============================================================
  roles: {
    admin: 'Sistemos administratorius',
    excon: 'Pratybų valdytojas',
    eu: 'ES koordinatorius',
    planner: 'Planuotojas',
    hub: 'Mazgo vadovas',
    nation: 'Šalis',
    readOnly: 'Tik skaitymas',
    systemAdmin: 'Sistemos administratorius',
    transportPlanner: 'Transporto planuotojas',
    systemRoles: 'Sistemos rolės',
  },

  // ============================================================
  // STATUS — Request, offer, mission statuses
  // ============================================================
  status: {
    draft: 'Juodraštis',
    underReview: 'Peržiūrima',
    published: 'Paskelbta',
    underSelection: 'Atranka vyksta',
    accepted: 'Priimta',
    planned: 'Suplanuota',
    inTransit: 'Vežama',
    completed: 'Užbaigta',
    closed: 'Uždaryta',
    withdrawn: 'Atšaukta',
    pending: 'Laukiama',
    rejected: 'Atmesta',
    cancelled: 'Atšaukta',
    active: 'Aktyvi',
    inactive: 'Neaktyvi',
    review: 'Peržiūra',
    selection: 'Atranka',
    transit: 'Vežimas',
  },

  // ============================================================
  // CATEGORIES — Request categories
  // ============================================================
  categories: {
    medevac: 'MEDEVAC',
    personnel: 'Personalas',
    material: 'Medžiagos',
    equipment: 'Įranga',
    other: 'Kita',
    news: 'Naujienos',
  },

  // ============================================================
  // URGENCY — Urgency levels
  // ============================================================
  urgency: {
    routine: 'Eilinis',
    priority: 'Prioritetinis',
    urgent: 'Skubus',
    immediate: 'Neatidėliotinas',
  },

  // ============================================================
  // ASSETS — Transport asset types
  // ============================================================
  assetTypes: {
    train: 'Traukinys',
    ship: 'Laivas',
    aircraft: 'Orlaivis',
    bus: 'Autobusas',
    ambulance: 'Greitoji pagalba',
    drone: 'Dronas',
    helicopter: 'Sraigtasparnis',
    ferry: 'Keltas',
    other: 'Kita',
  },

  // ============================================================
  // DASHBOARD
  // ============================================================
  dashboard: {
    title: 'Valdymo skydelis',
    goodMorning: 'Labas rytas',
    goodAfternoon: 'Laba diena',
    goodEvening: 'Labas vakaras',
    lastLogin: 'Paskutinis prisijungimas',
    infrastructure: 'Infrastruktūra',
    transportAssets: 'Transporto ištekliai',
    treatmentFacilities: 'Gydymo įstaigos',
    ucpmExitHubs: 'UCPM Exit Hubs',
    ucpmTransitHubs: 'UCPM Transit Hubs',
    requestStatistics: 'Užklausų statistika',
    viewAllRequests: 'Peržiūrėti visas užklausas',
    availableAssets: 'Turimi ištekliai',
    seated: 'Sėdimi',
    lying: 'Gulimi',
    intensive: 'Intensyvūs',
    notifications: 'Pranešimai',
    markAllRead: 'Žymėti visus kaip skaitytus',
    noNotifications: 'Pranešimų dar nėra',
    notifiedWhenActivity: 'Būsite informuoti, kai bus naujų veiksmų',
    viewDetailsBtn: 'Peržiūrėti išsamiau',
    nationUsers: 'Šalies naudotojai',
    user: 'Naudotojas',
    roles: 'Rolės',
    noUsersFound: 'Naudotojų nerasta',
    participatingNations: 'Dalyvaujančios šalys',
    exerciseDisclaimer: 'Ši sistema skirta tik pratyboms. Įveskite tik simuliuotus pratybų duomenis. Darbo eiga yra pritaikyta pratybų scenarijui ir gali skirtis nuo realių procedūrų. IT saugumo ir duomenų apsaugos taisyklės galioja visa apimtimi.',
    notConfigured: 'Nesukonfigūruota',
    requestCount: '{{count}} užklausa(-ų)',
    clickToView: 'Spustelėkite norėdami peržiūrėti',
    systemAdministration: 'Sistemos administravimas',
    exerciseControlTitle: 'Pratybų valdymas',
    euCoordination: 'ES koordinavimas',
    transportPlanningTitle: 'Transporto planavimas',
    hubManagement: 'Mazgų valdymas',
  },

  // ============================================================
  // QUICK ACTIONS
  // ============================================================
  quickActions: {
    newRequest: 'Nauja užklausa',
    myDrafts: 'Mano juodraščiai',
    pendingReview: 'Laukia peržiūros',
    activeTransports: 'Aktyvūs transportai',
    myPatients: 'Mano pacientai',
  },

  // ============================================================
  // REQUESTS
  // ============================================================
  requests: {
    title: 'Užklausos',
    newRequest: 'Nauja užklausa',
    createRequest: 'Sukurti užklausą',
    editRequest: 'Redaguoti užklausą',
    requestDetail: 'Užklausos informacija',
    requestId: 'Užklausos ID',
    fromNation: 'Iš šalies',
    toNation: 'Šaliai',
    requestingNation: 'Prašanti šalis',
    receivingNation: 'Priimanti šalis',
    category: 'Kategorija',
    urgency: 'Skubumas',
    status: 'Būsena',
    patients: 'Pacientai',
    patientCount: 'Pacientų skaičius',
    offers: 'Pasiūlymai',
    offerCount: 'Pasiūlymų skaičius',
    created: 'Sukurta',
    updated: 'Atnaujinta',
    submittedBy: 'Pateikė',
    reviewedBy: 'Peržiūrėjo',
    description: 'Aprašymas',
    medicalDetails: 'Medicininė informacija',
    transportDetails: 'Transporto informacija',
    additionalInfo: 'Papildoma informacija',
    exitHub: 'UCPM Exit Hub',
    departurePoint: 'Išvykimo taškas',
    arrivalPoint: 'Atvykimo taškas',
    estimatedDeparture: 'Numatomas išvykimas',
    estimatedArrival: 'Numatomas atvykimas',
    submitForReview: 'Pateikti peržiūrai',
    publish: 'Paskelbti',
    startSelection: 'Pradėti atranką',
    acceptOffer: 'Priimti pasiūlymą',
    markInTransit: 'Pažymėti kaip vežamą',
    markCompleted: 'Pažymėti kaip užbaigtą',
    closeRequest: 'Uždaryti užklausą',
    withdrawRequest: 'Atšaukti užklausą',
    withdraw: 'Atšaukti',
    revertToDraft: 'Grąžinti į juodraštį',
    deleteRequest: 'Ištrinti užklausą',
    duplicateRequest: 'Dubliuoti užklausą',
    createFollowUp: 'Sukurti konsoliduotą užklausą',
    followUpRequest: 'Konsoliduota užklausa',
    parentRequest: 'Pradinė užklausa',
    childRequests: 'Konsoliduotos užklausos',
    noRequests: 'Užklausų nerasta',
    noOffers: 'Pasiūlymų dar nėra',
    addPatient: 'Pridėti pacientą',
    removePatient: 'Pašalinti pacientą',
    patientDetails: 'Paciento informacija',
    contactPerson: 'Kontaktinis asmuo',
    contactPhone: 'Kontaktinis telefonas',
    contactEmail: 'Kontaktinis el. paštas',
    specialRequirements: 'Specialūs reikalavimai',
    medicalEquipment: 'Medicininė įranga',
    accompaniment: 'Palydėjimas',
    timeline: 'Laiko juosta',
    history: 'Istorija',
    addComment: 'Pridėti komentarą',
    writeComment: 'Parašykite komentarą...',
    postComment: 'Skelbti komentarą',
    posting: 'Skelbiama...',
    noComments: 'Komentarų dar nėra',
    coverageBar: 'Padengimas',
    covered: 'padengta',
    uncovered: 'nepadengta',
    filterByStatus: 'Filtruoti pagal būseną',
    filterByCategory: 'Filtruoti pagal kategoriją',
    filterByNation: 'Filtruoti pagal šalį',
    searchRequests: 'Ieškoti užklausų...',
    confirmWithdraw: 'Ar tikrai norite atšaukti šią užklausą?',
    confirmDelete: 'Ar tikrai norite ištrinti šią užklausą?',
    confirmPublish: 'Ar tikrai norite paskelbti šią užklausą? Ji bus matoma visoms šalims.',
    confirmStartSelection: 'Ar tikrai norite pradėti atranką? Šalys galės teikti pasiūlymus.',
    warningStartSelection: 'Pradėjus atranką, ši užklausa bus matoma visoms dalyvaujančioms šalims. Jos galės pateikti pasiūlymus dėl šios užklausos pacientų. Šio veiksmo negalima atšaukti.',
    warningMakeOffer: 'Pateikdami šį pasiūlymą, jūs įsipareigojate savo šalies vardu suteikti siūlomą pagalbą. Šis veiksmas informuos prašančią šalį ir pratybų valdymą.',
    saveDraft: 'Išsaugoti juodraštį',
    saving: 'Saugoma...',
    saveAndSubmit: 'Išsaugoti ir pateikti',
    step: '{{number}} žingsnis',
    generalInfo: 'Bendra informacija',
    patientInfo: 'Paciento informacija',
    logisticsInfo: 'Logistikos informacija',
    reviewSubmit: 'Peržiūra ir pateikimas',
    requestTitle: 'Užklausos pavadinimas',
    requestDescription: 'Užklausos aprašymas',
    numberOfPatients: 'Pacientų skaičius',
    typeOfAssistance: 'Pagalbos tipas',
    medicalTreatment: 'Medicininis gydymas',
    transportAssistance: 'Transporto pagalba',
    both: 'Abu',
    treatmentOnly: 'Tik gydymas',
    transportOnly: 'Tik transportas',
    validationErrors: 'Prašome ištaisyti šias klaidas:',
    fieldRequired: 'Šis laukas yra privalomas',
    selectExitHub: 'Pasirinkite išvykimo mazgą',
    createExitHub: 'Sukurti išvykimo mazgą',
    backToRequests: 'Grįžti prie užklausų',
    noRequestsFound: 'Užklausų nerasta',
    createFirstRequest: 'Sukurkite pirmąją užklausą, kad pradėtumėte',
  },

  // ============================================================
  // OFFERS
  // ============================================================
  offers: {
    title: 'Pasiūlymai',
    createOffer: 'Sukurti pasiūlymą',
    makeOffer: 'Pateikti pasiūlymą',
    manageOffers: 'Valdyti pasiūlymus',
    offerDetail: 'Pasiūlymo informacija',
    offerId: 'Pasiūlymo ID',
    offeringNation: 'Siūlanti šalis',
    offerType: 'Pasiūlymo tipas',
    treatment: 'Gydymas',
    transport: 'Transportas',
    combined: 'Kombinuotas',
    fullOffer: 'Full Offer',
    treatmentOffer: 'Gydymo pasiūlymas',
    transportOffer: 'Transporto pasiūlymas',
    combinedOffer: 'Combined Offer',
    selectPatients: 'Pasirinkti pacientus',
    selectedPatients: 'Pasirinkti pacientai',
    patientSelection: 'Pacientų atranka',
    offerConfiguration: 'Pasiūlymo konfigūracija',
    reviewOffer: 'Peržiūrėti pasiūlymą',
    submitOffer: 'Pateikti pasiūlymą',
    submitting: 'Pateikiama...',
    acceptOffer: 'Priimti pasiūlymą',
    rejectOffer: 'Atmesti pasiūlymą',
    withdrawOffer: 'Atšaukti pasiūlymą',
    noOffers: 'Pasiūlymų nėra',
    noOffer: 'No Offer',
    offerStatus: 'Pasiūlymo būsena',
    offerDate: 'Pasiūlymo data',
    transportAsset: 'Transporto priemonė',
    departureDate: 'Išvykimo data',
    arrivalDate: 'Atvykimo data',
    treatmentFacility: 'Gydymo įstaiga',
    capacity: 'Pajėgumas',
    availableCapacity: 'Turimas pajėgumas',
    totalCapacity: 'Bendras pajėgumas',
    selectAsset: 'Pasirinkti išteklių',
    selectFacility: 'Pasirinkti įstaigą',
    offerNotes: 'Pasiūlymo pastabos',
    confirmAccept: 'Ar tikrai norite priimti šį pasiūlymą?',
    confirmReject: 'Ar tikrai norite atmesti šį pasiūlymą?',
    extendTransport: 'Pratęsti transportą',
    transportExtension: 'Transporto pratęsimas',
    comparisonView: 'Palyginimo vaizdas',
    shortlist: 'Atrankos sąrašas',
    addToShortlist: 'Įtraukti į atrankos sąrašą',
    removeFromShortlist: 'Pašalinti iš atrankos sąrašo',
    leaveConfirmTitle: 'Palikti šį puslapį?',
    leaveConfirmMessage: 'Turite neišsaugotų pakeitimų. Ar tikrai norite palikti šį puslapį?',
    stayOnPage: 'Likti puslapyje',
    leavePage: 'Palikti puslapį',
  },

  // ============================================================
  // MISSIONS / TRANSPORTS
  // ============================================================
  missions: {
    title: 'Transportai',
    missionDetail: 'Transporto informacija',
    missionId: 'Transporto ID',
    missionStatus: 'Transporto būsena',
    createMission: 'Sukurti transportą',
    overview: 'Apžvalga',
    patientsTab: 'Pacientai',
    transportsTab: 'Transporto atkarpos',
    treatmentTab: 'Gydymas',
    reviewTab: 'Peržiūra',
    departure: 'Išvykimas',
    arrival: 'Atvykimas',
    origin: 'Kilmė',
    destination: 'Paskirties vieta',
    stops: 'Stotelės',
    addStop: 'Pridėti stotelę',
    removeStop: 'Pašalinti stotelę',
    stopName: 'Stotelės pavadinimas',
    stopType: 'Stotelės tipas',
    estimatedTime: 'Numatomas laikas',
    actualTime: 'Faktinis laikas',
    asset: 'Išteklius',
    driver: 'Vairuotojas',
    crew: 'Įgula',
    noMissions: 'Transportų nerasta',
    completeMission: 'Užbaigti transportą',
    cancelMission: 'Atšaukti transportą',
    startTransport: 'Pradėti transportą',
    missionChain: 'Transporto grandinė',
    linkedMissions: 'Susiję transportai',
    handover: 'Perdavimas',
    handoverPoint: 'Perdavimo taškas',
    pickupPoint: 'Paėmimo taškas',
    dropoffPoint: 'Iškrovimo taškas',
    searchTransports: 'Ieškoti transportų...',
  },

  // ============================================================
  // PATIENTS
  // ============================================================
  patients: {
    title: 'Pacientai',
    myPatients: 'Mano pacientai',
    patientId: 'Paciento ID',
    firstName: 'Vardas',
    lastName: 'Pavardė',
    dateOfBirth: 'Gimimo data',
    age: 'Amžius',
    gender: 'Lytis',
    male: 'Vyras',
    female: 'Moteris',
    other: 'Kita',
    nationality: 'Pilietybė',
    diagnosis: 'Diagnozė',
    condition: 'Būklė',
    stable: 'Stabili',
    critical: 'Kritinė',
    serious: 'Sunki',
    treatmentNeeded: 'Reikalingas gydymas',
    allergies: 'Alergijos',
    medications: 'Vaistai',
    bloodType: 'Kraujo grupė',
    weight: 'Svoris (kg)',
    infectious: 'Infekcinė liga',
    mentalHealth: 'Psichinė sveikata',
    mobility: 'Mobilumas',
    ambulatory: 'Vaikštantis',
    wheelchair: 'Neįgaliojo vežimėlis',
    stretcher: 'Neštuvai',
    intensive: 'Intensyvioji priežiūra',
    oxygenRequired: 'Reikalingas deguonis',
    ventilator: 'Ventiliatorius',
    medicalEscort: 'Medicininis palydėjimas',
    noPatients: 'Pacientų nerasta',
    patientDetails: 'Paciento informacija',
    medicalHistory: 'Medicininė istorija',
    travelDocuments: 'Kelionės dokumentai',
    passport: 'Pasas',
    pseudonymizedId: 'Pseudonimizuotas ID',
    sensitiveData: 'Jautrūs duomenys',
    journey: 'Paciento kelionė',
    assignedTo: 'Priskirta',
    currentLocation: 'Dabartinė vieta',
    importPatients: 'Importuoti pacientus',
    exportPatients: 'Eksportuoti pacientus',
    seated: 'Sėdimi',
    lying: 'Gulimi',
  },

  // ============================================================
  // USERS
  // ============================================================
  users: {
    title: 'Naudotojai',
    createUser: 'Sukurti naudotoją',
    editUser: 'Redaguoti naudotoją',
    deleteUser: 'Ištrinti naudotoją',
    username: 'Naudotojo vardas',
    displayName: 'Rodomas vardas',
    email: 'El. paštas',
    password: 'Slaptažodis',
    role: 'Rolė',
    roles: 'Rolės',
    nation: 'Šalis',
    active: 'Aktyvus',
    lastLogin: 'Paskutinis prisijungimas',
    createdAt: 'Sukurta',
    isNation: 'Šalis',
    isEU: 'ES',
    isAdmin: 'Administratorius',
    isExcon: 'EXCON',
    isPlanner: 'Planuotojas',
    isHub: 'Mazgas',
    isReadOnly: 'Tik skaitymas',
    noUsers: 'Naudotojų nerasta',
    confirmDelete: 'Ar tikrai norite ištrinti šį naudotoją?',
    resetPassword: 'Atstatyti slaptažodį',
    generatePassword: 'Generuoti slaptažodį',
    searchUsers: 'Ieškoti naudotojų...',
    userCreated: 'Naudotojas sėkmingai sukurtas',
    userUpdated: 'Naudotojas sėkmingai atnaujintas',
    userDeleted: 'Naudotojas sėkmingai ištrintas',
    selectNation: 'Pasirinkite šalį',
    mustChangePassword: 'Pakeisti slaptažodį kitą kartą prisijungus',
    flagImage: 'Vėliavos nuotrauka',
    exportUsers: 'Eksportuoti naudotojus',
    importUsers: 'Importuoti naudotojus',
  },

  // ============================================================
  // ASSETS
  // ============================================================
  assets: {
    title: 'Ištekliai',
    createAsset: 'Sukurti išteklių',
    editAsset: 'Redaguoti išteklių',
    deleteAsset: 'Ištrinti išteklių',
    assetName: 'Ištekliaus pavadinimas',
    assetType: 'Ištekliaus tipas',
    capacitySeated: 'Pajėgumas (sėdimi)',
    capacityLying: 'Pajėgumas (gulimi)',
    capacityIntensive: 'Pajėgumas (intensyvūs)',
    owner: 'Savininkas',
    operator: 'Operatorius',
    baseLocation: 'Bazinė vieta',
    range: 'Nuotolis',
    speed: 'Greitis',
    noAssets: 'Išteklių nerasta',
    confirmDelete: 'Ar tikrai norite ištrinti šį išteklių?',
    searchAssets: 'Ieškoti išteklių...',
    assetCreated: 'Išteklius sėkmingai sukurtas',
    assetUpdated: 'Išteklius sėkmingai atnaujintas',
    assetDeleted: 'Išteklius sėkmingai ištrintas',
    exportAssets: 'Eksportuoti išteklius',
  },

  // ============================================================
  // HUBS / START POINTS
  // ============================================================
  hubs: {
    title: 'Mazgai',
    startPoints: 'Pradžios taškai',
    createHub: 'Sukurti mazgą',
    editHub: 'Redaguoti mazgą',
    deleteHub: 'Ištrinti mazgą',
    hubName: 'Mazgo pavadinimas',
    hubType: 'Mazgo tipas',
    exitHub: 'UCPM Exit Hub',
    transitHub: 'UCPM Transit Hub',
    entryHub: 'Įvažiavimo mazgas',
    airport: 'Oro uostas',
    seaport: 'Jūrų uostas',
    railStation: 'Geležinkelio stotis',
    roadPoint: 'Kelių taškas',
    ucpmClassification: 'UCPM klasifikacija',
    icaoCode: 'ICAO kodas',
    iataCode: 'IATA kodas',
    noHubs: 'Mazgų nerasta',
    confirmDelete: 'Ar tikrai norite ištrinti šį mazgą?',
    searchHubs: 'Ieškoti mazgų...',
    nationAssignment: 'Šalių priskyrimas',
    assignNations: 'Priskirti šalis',
  },

  // ============================================================
  // HOSPITALS / TREATMENT FACILITIES
  // ============================================================
  hospitals: {
    title: 'Gydymo įstaigos',
    createFacility: 'Sukurti įstaigą',
    editFacility: 'Redaguoti įstaigą',
    deleteFacility: 'Ištrinti įstaigą',
    facilityName: 'Įstaigos pavadinimas',
    facilityType: 'Įstaigos tipas',
    hospitalName: 'Ligoninės pavadinimas',
    bedCapacity: 'Lovų pajėgumas',
    specialties: 'Specializacijos',
    availableBeds: 'Laisvos lovos',
    totalBeds: 'Iš viso lovų',
    contactPerson: 'Kontaktinis asmuo',
    noFacilities: 'Gydymo įstaigų nerasta',
    confirmDelete: 'Ar tikrai norite ištrinti šią įstaigą?',
    searchFacilities: 'Ieškoti įstaigų...',
    hubNationAssignment: 'Mazgo šalių priskyrimas',
  },

  // ============================================================
  // SCHEDULES
  // ============================================================
  schedules: {
    title: 'Tvarkaraščiai',
    createSchedule: 'Sukurti tvarkaraštį',
    editSchedule: 'Redaguoti tvarkaraštį',
    deleteSchedule: 'Ištrinti tvarkaraštį',
    scheduleName: 'Tvarkaraščio pavadinimas',
    scheduleType: 'Tvarkaraščio tipas',
    recurring: 'Pasikartojantis',
    oneTime: 'Vienkartinis',
    frequency: 'Dažnumas',
    daily: 'Kasdien',
    weekly: 'Kas savaitę',
    startDate: 'Pradžios data',
    endDate: 'Pabaigos data',
    departureTime: 'Išvykimo laikas',
    arrivalTime: 'Atvykimo laikas',
    stops: 'Stotelės',
    addStop: 'Pridėti stotelę',
    noSchedules: 'Tvarkaraščių nerasta',
    bookings: 'Rezervacijos',
    timeline: 'Laiko juosta',
  },

  // ============================================================
  // NOTIFICATIONS
  // ============================================================
  notifications: {
    title: 'Pranešimai',
    markAllRead: 'Žymėti visus kaip skaitytus',
    markAsRead: 'Žymėti kaip skaitytą',
    markAsUnread: 'Žymėti kaip neskaitytą',
    noNotifications: 'Pranešimų nėra',
    viewAll: 'Peržiūrėti visus pranešimus',
    settings: 'Pranešimų nustatymai',
    emailNotifications: 'El. pašto pranešimai',
    inAppNotifications: 'Pranešimai programoje',
    notifyOn: 'Pranešti apie',
    requestCreated: 'Nauja užklausa',
    requestPublished: 'Užklausa paskelbta',
    requestClosed: 'Užklausa uždaryta',
    requestCompleted: 'Užklausa užbaigta',
    commentAdded: 'Naujas komentaras',
    offerReceived: 'Gautas pasiūlymas',
    offerAccepted: 'Pasiūlymas priimtas',
    statusChanged: 'Būsena pasikeitė',
    selectionStarted: 'Atranka pradėta',
    missionCreated: 'Transportas sukurtas',
    missionStatusUpdated: 'Transportas atnaujintas',
    transportPartnerNamed: 'Transporto partneris',
    transportExtensionReceived: 'Transporto pratęsimas',
  },

  // ============================================================
  // SETTINGS
  // ============================================================
  settings: {
    title: 'Nustatymai',
    general: 'Bendrieji',
    system: 'Sistema',
    email: 'El. paštas',
    sync: 'Sinchronizavimas',
    security: 'Saugumas',
    appearance: 'Išvaizda',
    systemName: 'Sistemos pavadinimas',
    systemEmail: 'Sistemos el. paštas',
    maintenanceMode: 'Priežiūros režimas',
    readOnlyMode: 'Tik skaitymo režimas',
    emailEnabled: 'El. paštas įjungtas',
    smtpHost: 'SMTP serveris',
    smtpPort: 'SMTP prievadas',
    smtpUser: 'SMTP naudotojas',
    smtpPassword: 'SMTP slaptažodis',
    senderEmail: 'Siuntėjo el. paštas',
    senderName: 'Siuntėjo vardas',
    testEmail: 'Siųsti bandomąjį el. laišką',
    syncEnabled: 'Sinchronizavimas įjungtas',
    syncUrl: 'Sinchronizavimo URL',
    syncApiKey: 'Sinchronizavimo API raktas',
    settingsSaved: 'Nustatymai sėkmingai išsaugoti',
    helpdesk: 'Pagalbos tarnyba',
    helpdeskTitle: 'Pagalbos tarnybos pavadinimas',
    helpdeskEmail: 'Pagalbos tarnybos el. paštas',
    helpdeskPhone: 'Pagalbos tarnybos telefonas',
    helpdeskInfo: 'Pagalbos tarnybos informacija',
    realLifeSupport: 'Pagalba realiomis aplinkybėmis',
    trainingMode: 'Mokymo režimas',
  },

  // ============================================================
  // AUDIT LOGS
  // ============================================================
  auditLogs: {
    title: 'Audito žurnalas',
    action: 'Veiksmas',
    user: 'Naudotojas',
    target: 'Objektas',
    details: 'Išsamiau',
    timestamp: 'Laiko žyma',
    ipAddress: 'IP adresas',
    noLogs: 'Audito įrašų nerasta',
    searchLogs: 'Ieškoti įrašų...',
    filterByAction: 'Filtruoti pagal veiksmą',
    filterByUser: 'Filtruoti pagal naudotoją',
    exportLogs: 'Eksportuoti žurnalą',
    exportCsv: 'Eksportuoti CSV',
  },

  // ============================================================
  // EXERCISE CONTROL
  // ============================================================
  exerciseControl: {
    title: 'Pratybų valdymas',
    currentDay: 'Dabartinė diena',
    exerciseDay: 'Pratybų diena',
    nextDay: 'Kita diena',
    previousDay: 'Ankstesnė diena',
    resetExercise: 'Atstatyti pratybas',
    startExercise: 'Pradėti pratybas',
    endExercise: 'Baigti pratybas',
    dayReset: 'Dienos atstatymas',
    confirmReset: 'Ar tikrai norite atstatyti pratybų dieną? Visi dabartinės dienos duomenys bus ištrinti.',
    resetInProgress: 'Vykdomas atstatymas...',
    maintenanceMode: 'Priežiūros režimas',
    enableMaintenance: 'Įjungti priežiūrą',
    disableMaintenance: 'Išjungti priežiūrą',
  },

  // ============================================================
  // DATA SYNC
  // ============================================================
  dataSync: {
    title: 'Duomenų sinchronizavimas',
    syncStatus: 'Sinchronizavimo būsena',
    lastSync: 'Paskutinis sinchronizavimas',
    pendingItems: 'Laukiantys elementai',
    syncNow: 'Sinchronizuoti dabar',
    syncing: 'Sinchronizuojama...',
    syncSuccess: 'Sinchronizavimas sėkmingai baigtas',
    syncFailed: 'Sinchronizavimas nepavyko',
    outbox: 'Siuntimo dėžutė',
    inbox: 'Gavimo dėžutė',
    configuration: 'Konfigūracija',
    targetUrl: 'Paskirties URL',
    apiKey: 'API raktas',
  },

  // ============================================================
  // MAP
  // ============================================================
  map: {
    title: 'Žemėlapis',
    layers: 'Sluoksniai',
    requests: 'Užklausos',
    hubs: 'Mazgai',
    facilities: 'Įstaigos',
    routes: 'Maršrutai',
    showAll: 'Rodyti viską',
    hideAll: 'Slėpti viską',
    zoomIn: 'Priartinti',
    zoomOut: 'Atitolinti',
    resetView: 'Atstatyti vaizdą',
    satellite: 'Palydovinis',
    terrain: 'Reljefo',
    offline: 'Neprisijungęs',
    online: 'Prisijungęs',
    tilesOffline: 'Žemėlapio plytelės aptarnaujamos vietoje',
    tilesOnline: 'Žemėlapio plytelės kraunamos iš internetinių serverių',
  },

  // ============================================================
  // STATISTICS
  // ============================================================
  statistics: {
    title: 'Statistika',
    overview: 'Apžvalga',
    requestsByStatus: 'Užklausos pagal būseną',
    requestsByCategory: 'Užklausos pagal kategoriją',
    requestsByNation: 'Užklausos pagal šalį',
    offersByStatus: 'Pasiūlymai pagal būseną',
    patientsByCondition: 'Pacientai pagal būklę',
    transportsByStatus: 'Transportai pagal būseną',
    timeline: 'Laiko juosta',
    totalRequests: 'Iš viso užklausų',
    totalOffers: 'Iš viso pasiūlymų',
    totalPatients: 'Iš viso pacientų',
    totalTransports: 'Iš viso transportų',
    averageResponseTime: 'Vidutinis atsakymo laikas',
    completionRate: 'Užbaigimo rodiklis',
  },

  // ============================================================
  // EXERCISE STATS
  // ============================================================
  exerciseStats: {
    title: 'Pratybų statistika',
    overview: 'Apžvalga',
    byCategory: 'Pagal kategoriją',
    byNation: 'Pagal šalį',
    byDay: 'Pagal dieną',
    totalPatientsMoved: 'Iš viso pervežtų pacientų',
    totalRequestsProcessed: 'Iš viso apdorotų užklausų',
    averageProcessingTime: 'Vidutinis apdorojimo laikas',
  },

  // ============================================================
  // FLOW DIAGRAM
  // ============================================================
  flowDiagram: {
    title: 'Srauto diagrama',
    sankey: 'Sankey',
    nodeGraph: 'Mazgų grafas',
    refresh: 'Atnaujinti',
    noData: 'Srauto duomenų nėra',
  },

  // ============================================================
  // ABOUT
  // ============================================================
  about: {
    title: 'Apie',
    version: 'Versija',
    systemInfo: 'Sistemos informacija',
    buildDate: 'Sukūrimo data',
    environment: 'Aplinka',
    description: 'ARCOS — Pažangi užklausų komunikacijos sistema',
    subtitle: 'Nukentėjusiųjų pagalba ir medicininės operacijos',
    whatIsArcos: 'Kas yra ARCOS? – Paaiškinimas pratybų dalyviams',
    arcosDesc1: 'ARCOS is a digital tool used in this exercise to support and structure international communication, requests and coordination processes between the participating actors. It is important to understand that ARCOS is not an operational system and does not replace real-world platforms such as CECIS (Common Emergency Communication and Information System) or EWRS (Early Warning and Response System).',
    arcosDesc2: 'Instead, ARCOS provides a simplified, exercise-oriented representation of the basic principles behind these systems. Its purpose is to allow participants to work within a common, consistent framework during the exercise, without requiring access to protected or operational environments.',
    arcosUsedFor: 'During the exercise, ARCOS is used to represent typical processes such as:',
    arcosUsedForItem1: 'submitting and managing requests for assistance (e.g. medical support, personnel or material),',
    arcosUsedForItem2: 'coordinating and responding to offers of support from other nations or organizations,',
    arcosUsedForItem3: 'tracking the status and progression of requests,',
    arcosUsedForItem4: 'and representing simplified transport or evacuation workflows.',
    arcosDesc3: 'The workflows in ARCOS are intentionally simplified and adapted to the specific training objectives of the exercise. In addition, ARCOS includes certain functions that do not exist in real systems but are useful for training and discussion purposes. This allows the exercise to focus on decision-making, coordination and cooperation rather than on technical system details.',
    arcosDesc4: 'The goal of ARCOS is not to simulate a perfect or complete real-world system. Instead, it aims to provide a clear, structured and shared understanding of how multinational coordination processes work in principle. ARCOS is meant to support the exercise, make communication transparent, and help participants concentrate on the exercise objectives.',
    arcosDesc5: 'If certain elements or workflows in ARCOS differ from real-life procedures you may be familiar with, this is expected. ARCOS reflects the logic of the exercise, not the full operational complexity of systems such as CECIS or EWRS.',
    facilitatedBy: 'Remia MMCC-E',
    dhcInitiative: 'The Digital Health Corner (DHC) is a joint initiative by:',
    dhcAuthor1: 'Sven Giegerich — German Armed Forces',
    dhcAuthor2: 'Mohamad Haji — Belgian Defence',
    dhcConviction: 'Born from the conviction that innovation thrives where passion meets pragmatism.',
    dhcInspired: 'Inspired by the initial spark ignited by MMCC-E, we set out to create simple yet effective solutions based on existing systems – tools that make Tabletop Exercises (TTX) more efficient, realistic, and accessible.',
    dhcLove: 'We do this because we love our work and we believe that digital ideas can reshape collaboration in military healthcare.',
    dhcOpen: 'The DHC is an open platform: free from hierarchies, open to ideas, driven by curiosity and a spirit of collaboration. We are looking for fellow innovators who share our enthusiasm – people who want to think, build, and create together.',
    dhcClosing: 'Digital Health Corner – kur smalsumas sutinka bendradarbiavimą.',
  },

  // ============================================================
  // DOCUMENTATION
  // ============================================================
  documentation: {
    title: 'Dokumentacija',
    gettingStarted: 'Pradžia',
    userGuide: 'Naudotojo vadovas',
    faq: 'DUK',
    troubleshooting: 'Trikčių šalinimas',
    apiReference: 'API nuoroda',
    downloadTemplate: 'Atsisiųsti šabloną',
    overviewDesc: 'CAMO26 is a simulation system for the CECIS workflow. As a <strong>Nation user</strong>, you can create and manage assistance requests, communicate with other nations, and coordinate medical support operations.',
    dashboardDesc: 'The Dashboard provides an overview of all requests in the system and shows statistics by status. Click on any statistic card to view filtered requests.',
    navigationInfo: 'Navigation Information',
    navDashboard: 'Dashboard - System overview and statistics',
    navRequests: 'Requests - View all requests in list format',
    navNewRequest: 'New Request - Create a new assistance request',
    navNotifications: 'Notifications - Bell icon in header shows new activities',
    step1Title: 'Step 1: Basic Information',
    step1Item1: 'Click <strong>"New Request"</strong> in the navigation menu',
    step1Item2: 'Enter a descriptive <strong>Title</strong> for your request',
    step1Item3: 'Provide detailed <strong>Description</strong> of what assistance is needed',
    step1Item4: 'Select the <strong>Category</strong>:',
    catMedevac: 'MEDEVAC - Medical evacuation of patients',
    catPersonnel: 'PERSONNEL - Request for medical personnel',
    catEquipment: 'EQUIPMENT - Request for medical equipment or supplies',
    catOther: 'OTHER - Other types of assistance',
    step1Item5: 'Set <strong>Urgency</strong> level (LOW, NORMAL, HIGH)',
    step1Item6: 'Optionally set an <strong>"Answer By"</strong> deadline',
    step2Title: 'Step 2: Add Patient Data (MEDEVAC only)',
    step2Desc: 'For MEDEVAC requests, you can add patient information:',
    step2ManualEntry: 'Manual Entry - Fill out the patient form for each individual',
    step2ExcelUpload: 'Excel Upload - Upload a pre-filled Excel file with patient data',
    step2ExcelItem1: 'Download the template from the request page',
    step2ExcelItem2: 'Fill in patient details following the format',
    step2ExcelItem3: 'Upload the completed file',
    step3Title: 'Step 3: Submit for Review',
    step3Desc: 'Once your request is complete, submit it for EU review. The request moves to <strong>"UNDER_REVIEW"</strong> status and EU coordinators are notified.',
    requestWorkflow: 'Request Workflow',
    workflowDraft: 'Initial creation - only visible to you',
    workflowReview: 'Submitted to EU for approval',
    workflowPublished: 'Visible to all nations - can receive offers',
    workflowTransit: 'Offer accepted - assistance in progress',
    workflowCompleted: 'Assistance successfully delivered',
    workflowNote: '<strong>Note:</strong> EU coordinators can also set requests to <strong>CLOSED</strong> status if needed.',
    viewingRequests: 'Viewing and Managing Requests',
    ownRequests: 'Your Own Requests',
    ownRequestItem1: 'View all your requests regardless of status',
    ownRequestItem2: 'Edit DRAFT requests before submission',
    ownRequestItem3: 'Track status changes and updates',
    ownRequestItem4: 'Accept offers from other nations',
    ownRequestItem5: 'Mark requests as COMPLETED when assistance is delivered',
    otherRequests: 'Other Nations\' Requests',
    otherRequestItem1: 'View all PUBLISHED requests from other nations',
    otherRequestItem2: 'Add comments to discuss details',
    otherRequestItem3: 'Submit offers to provide assistance',
    otherRequestItem4: 'Track which requests have been fulfilled',
    fullOffer: 'Full Offer',
    fullOfferDesc: 'You can fulfill the entire request:',
    fullOfferItem1: 'Open a PUBLISHED request from another nation',
    fullOfferItem2: 'Click <strong>"Make Offer"</strong>',
    fullOfferItem3: 'Describe what you can provide',
    fullOfferItem4: 'Submit the offer',
    partialOffer: 'Partial Offer (MEDEVAC only)',
    partialOfferDesc: 'For MEDEVAC requests, you can offer to take some patients:',
    partialOfferItem1: 'Select specific patients from the list',
    partialOfferItem2: 'Describe your capacity and capabilities',
    partialOfferItem3: 'Submit the partial offer',
    offerImportant: '<strong>Important:</strong> The requesting nation must accept your offer before it becomes active.',
    commentsUsage: 'Use comments on PUBLISHED requests to:',
    commentItem1: 'Ask questions about requirements',
    commentItem2: 'Clarify details before making an offer',
    commentItem3: 'Coordinate logistics and timing',
    commentItem4: 'Share updates during execution',
    notifDesc: 'You receive notifications for:',
    notifItem1: 'New published requests from other nations',
    notifItem2: 'Comments on your requests or requests you\'ve interacted with',
    notifItem3: 'Offers received on your requests',
    notifItem4: 'Status changes on your requests',
    notifItem5: 'Offer acceptance/rejection',
    notifBell: 'Check the bell icon in the header to view notifications. The badge shows unread count.',
    requestIdFormat: 'Request ID Format',
    requestIdDesc: 'Each request receives a unique ID in the format: <code>XXX-YYYY-AAA</code>',
    requestIdPart1: '<strong>XXX</strong> - Your nation\'s ISO 3166-1 alpha-3 code (e.g., DEU, FRA, GBR)',
    requestIdPart2: '<strong>YYYY</strong> - Current year',
    requestIdPart3: '<strong>AAA</strong> - Sequential number for your nation this year',
    requestIdExample: '<strong>Example:</strong> <code>DEU-2025-001</code> is Germany\'s first request in 2025',
    bestPractices: 'Best Practices',
    effectiveRequests: 'Creating Effective Requests',
    effectiveItem1: 'Use clear, descriptive titles',
    effectiveItem2: 'Provide complete details in the description',
    effectiveItem3: 'Set realistic urgency levels',
    effectiveItem4: 'For MEDEVAC: Include accurate patient information',
    effectiveItem5: 'Set appropriate deadlines for responses',
    collaboration: 'Collaboration',
    collabItem1: 'Respond promptly to comments on your requests',
    collabItem2: 'Review offers carefully before accepting',
    collabItem3: 'Update request status as situations evolve',
    collabItem4: 'Mark requests as COMPLETED when assistance is delivered',
    collabItem5: 'Communicate any changes or issues through comments',
    systemEtiquette: 'System Etiquette',
    etiquetteItem1: 'Only submit requests for review when they are complete',
    etiquetteItem2: 'Do not create duplicate requests',
    etiquetteItem3: 'Use appropriate urgency levels - reserve HIGH for true emergencies',
    etiquetteItem4: 'Close or complete requests that are no longer needed',
    supportDesc: 'For technical issues or questions about using the system, please contact:',
    supportContact: 'Multinational Medical Coordination Centre - Europe (MMCC-E)',
    importantNotice: 'Important Notice',
    importantNoticeText1: 'This is a simulation system for training and exercise purposes only.',
    importantNoticeText2: 'CAMO26 simulates the basic workflow of CECIS (Common Emergency Communication and Information System). Many CECIS functions are not represented here. This system is designed for tabletop exercises (TTX) and should not be used for actual emergency operations.',
  },

  // ============================================================
  // PATIENT IMPORT
  // ============================================================
  patientImport: {
    title: 'Pacientų importas',
    uploadFile: 'Įkelti failą',
    selectFile: 'Pasirinkti failą',
    preview: 'Peržiūra',
    importNow: 'Importuoti dabar',
    importing: 'Importuojama...',
    importSuccess: '{{count}} pacientų sėkmingai importuota',
    importFailed: 'Importas nepavyko',
    downloadTemplate: 'Atsisiųsti šabloną',
    dragDrop: 'Vilkite ir numeskite failą čia arba spustelėkite, kad pasirinktumėte',
    supportedFormats: 'Palaikomi formatai: XLSX, XLS, CSV',
    rowsFound: 'Rasta {{count}} eilučių',
    validRows: '{{count}} tinkamų eilučių',
    invalidRows: '{{count}} netinkamų eilučių',
    duplicateRows: '{{count}} pasikartojančių eilučių',
    previewData: 'Peržiūrėti duomenis',
  },

  // ============================================================
  // TRANSPORT PLANNING / BOOKING
  // ============================================================
  transportPlanning: {
    title: 'Transporto planavimas',
    planRoute: 'Planuoti maršrutą',
    routeBuilder: 'Maršruto kūrimas',
    addWaypoint: 'Pridėti tarpinį tašką',
    removeWaypoint: 'Pašalinti tarpinį tašką',
    estimatedDuration: 'Numatoma trukmė',
    distance: 'Atstumas',
    selectVehicle: 'Pasirinkti transporto priemonę',
  },

  transportBooking: {
    title: 'Transporto rezervacija',
    bookTransport: 'Rezervuoti transportą',
    availableSlots: 'Laisvi laikai',
    bookingConfirmed: 'Rezervacija patvirtinta',
    cancelBooking: 'Atšaukti rezervaciją',
  },

  // ============================================================
  // CAPACITY PLANNING
  // ============================================================
  capacityPlanning: {
    title: 'Pajėgumų planavimas',
    totalCapacity: 'Bendras pajėgumas',
    usedCapacity: 'Panaudotas pajėgumas',
    availableCapacity: 'Turimas pajėgumas',
    utilizationRate: 'Panaudojimo rodiklis',
  },

  // ============================================================
  // TEMPLATES
  // ============================================================
  templates: {
    assetTemplates: 'Išteklių šablonai',
    dayTemplates: 'Dienos šablonai',
    createTemplate: 'Sukurti šabloną',
    editTemplate: 'Redaguoti šabloną',
    deleteTemplate: 'Ištrinti šabloną',
    templateName: 'Šablono pavadinimas',
    applyTemplate: 'Taikyti šabloną',
    noTemplates: 'Šablonų nerasta',
    confirmDelete: 'Ar tikrai norite ištrinti šį šabloną?',
    confirmApply: 'Ar tikrai norite taikyti šį šabloną? Tai perrašys esamus duomenis.',
    exportTemplates: 'Eksportuoti šablonus',
  },

  // ============================================================
  // ANNOUNCEMENT TICKER
  // ============================================================
  announcements: {
    title: 'Pranešimų juosta',
    createAnnouncement: 'Sukurti pranešimą',
    editAnnouncement: 'Redaguoti pranešimą',
    deleteAnnouncement: 'Ištrinti pranešimą',
    message: 'Žinutė',
    startTime: 'Pradžios laikas',
    endTime: 'Pabaigos laikas',
    active: 'Aktyvus',
    noAnnouncements: 'Pranešimų nėra',
    confirmDelete: 'Ar tikrai norite ištrinti šį pranešimą?',
  },

  // ============================================================
  // COMPONENTS — Reusable component strings
  // ============================================================
  components: {
    // DataTable
    dataTable: {
      search: 'Ieškoti...',
      noResults: 'Rezultatų nerasta',
      showing: 'Rodoma nuo {{from}} iki {{to}} iš {{total}}',
      rowsPerPage: 'Eilučių puslapyje',
      previousPage: 'Ankstesnis puslapis',
      nextPage: 'Kitas puslapis',
    },
    // ConfirmDialog
    confirmDialog: {
      confirm: 'Patvirtinti',
      cancel: 'Atšaukti',
    },
    // LeaveConfirmDialog
    leaveConfirm: {
      title: 'Neišsaugoti pakeitimai',
      message: 'Turite neišsaugotų pakeitimų. Ar tikrai norite palikti šį puslapį?',
      stay: 'Likti puslapyje',
      leave: 'Palikti puslapį',
    },
    // EmptyState
    emptyState: {
      noData: 'Duomenų nėra',
    },
    // ErrorBoundary
    errorBoundary: {
      title: 'Kažkas nepavyko',
      message: 'Įvyko netikėta klaida. Pabandykite atnaujinti puslapį.',
      retry: 'Bandyti dar kartą',
    },
    // ExportButton
    exportButton: {
      export: 'Eksportuoti',
      exporting: 'Eksportuojama...',
      csv: 'CSV',
      excel: 'Excel',
      pdf: 'PDF',
      print: 'Spausdinti',
    },
    // StatusProgressBar
    progressBar: {
      draft: 'Juodraštis',
      review: 'Peržiūra',
      published: 'Paskelbta',
      selection: 'Atranka',
      inTransit: 'Vežama',
      completed: 'Užbaigta',
    },
    // ReadOnlyBanner
    readOnlyBanner: {
      title: 'Internetinė instancija',
      message: 'Tik skaitymo režimas. Duomenys sinchronizuojami iš pagrindinio serverio.',
    },
    // ImpersonationBanner
    impersonationBanner: {
      viewingAs: 'Žiūrite kaip',
      loggedInAs: 'prisijungę kaip {{nation}}',
      returnTo: 'Grįžti į {{nation}}',
    },
    // GlobalSearch
    globalSearch: {
      placeholder: 'Ieškoti puslapių, užklausų, transportų...',
      searching: 'Ieškoma...',
      noResults: 'Rezultatų pagal „{{query}}" nerasta',
      navigate: 'Naršyti',
      select: 'Pasirinkti',
      close: 'Uždaryti',
      pages: {
        dashboard: 'Valdymo skydelis',
        requests: 'Užklausos',
        transports: 'Transportai',
        map: 'Žemėlapis',
        myPatients: 'Mano pacientai',
        flowDiagram: 'Srauto diagrama',
        statistics: 'Statistika',
        assets: 'Ištekliai',
        startPoints: 'Pradžios taškai / Mazgai',
        treatmentFacilities: 'Gydymo įstaigos',
        users: 'Naudotojai',
        settings: 'Nustatymai',
        auditLogs: 'Audito žurnalas',
        exerciseControl: 'Pratybų valdymas',
        dataSync: 'Duomenų sinchronizavimas',
        patientImport: 'Pacientų importas',
        notifications: 'Pranešimai',
        documentation: 'Dokumentacija',
      },
      actions: {
        importPatientsJson: 'Importuoti Pacientus (JSON)',
        importPatientsExcel: 'Importuoti Pacientus (Excel)',
        importUsers: 'Importuoti Vartotojus (Excel)',
        importAssetTemplates: 'Importuoti Turto šablonus (Excel)',
        importDayTemplates: 'Importuoti Dienos šablono įrašus (Excel)',
        exportRequests: 'Eksportuoti Užklausas (Excel)',
        exportPatients: 'Eksportuoti Pacientus (Excel)',
        exportUsers: 'Eksportuoti Vartotojus (Excel)',
        exportCredentials: 'Eksportuoti Prisijungimo duomenys (PDF)',
        exportAuditExcel: 'Eksportuoti Audito žurnalas (Excel)',
        exportAuditPdf: 'Eksportuoti Audito žurnalas (PDF)',
        pagePatientImport: 'Pacientų importo puslapis',
        pageRequestDetail: 'Užklausos detalių puslapis',
        pageUsers: 'Vartotojų valdymo puslapis',
        pageAssetTemplates: 'Turto šablonų puslapis',
        pageDayTemplates: 'Dienos šablonų puslapis',
        pageRequests: 'Užklausų sąrašo puslapis',
        pageAuditLogs: 'Audito žurnalo puslapis',
      },
    },
    // SessionTimeout
    sessionTimeout: {
      title: 'Sesija baigiasi',
      message: 'Jūsų sesija baigsis po <strong>{{time}}</strong>. Išsaugokite savo darbą ir prisijunkite iš naujo, kad galėtumėte tęsti.',
      dismiss: 'Atmesti',
      logoutNow: 'Atsijungti dabar',
    },
    // TimezoneClock
    timezoneClock: {
      selectTimezones: 'Pasirinkite 4 laiko juostas',
      configure: 'Konfigūruoti laiko juostas',
      reset: 'Atstatyti',
      apply: 'Taikyti',
    },
    // CoordinatePicker
    coordinatePicker: {
      pickLocation: 'Pasirinkti vietą',
      latitude: 'Platuma',
      longitude: 'Ilguma',
      clickToSelect: 'Spustelėkite žemėlapyje, kad pasirinktumėte vietą',
    },
    // Modal
    modal: {
      close: 'Uždaryti',
    },
    // Breadcrumb
    breadcrumb: {
      home: 'Pradžia',
    },
  },

  // ============================================================
  // MAINTENANCE SCREEN
  // ============================================================
  maintenance: {
    title: 'Sistemos priežiūra',
    message: 'Sistema atstatoma kitai pratybų dienai. Palaukite, kol procesas bus baigtas.',
    autoRefresh: 'Šis puslapis bus automatiškai atnaujintas, kai sistema vėl bus pasiekiama.',
  },

  // ============================================================
  // EXERCISE ANALYTICS
  // ============================================================
  exerciseAnalytics: {
    missionStatus: {
      draft: 'Draft',
      planned: 'Planned',
      active: 'Active',
      inTransit: 'In Transit',
      completed: 'Completed',
      cancelled: 'Cancelled',
    },
    actions: {
      USER_LOGIN: 'User Login',
      USER_LOGOUT: 'User Logout',
      USER_CREATED: 'User Created',
      USER_UPDATED: 'User Updated',
      USER_DELETED: 'User Deleted',
      REQUEST_CREATED: 'Request Created',
      REQUEST_UPDATED: 'Request Updated',
      REQUEST_SUBMITTED: 'Request Submitted',
      REQUEST_PUBLISHED: 'Request Published',
      REQUEST_CLOSED: 'Request Closed',
      REQUEST_COMPLETED: 'Request Completed',
      OFFER_CREATED: 'Offer Created',
      OFFER_UPDATED: 'Offer Updated',
      OFFER_ACCEPTED: 'Offer Accepted',
      OFFER_DELETED: 'Offer Deleted',
      MISSION_CREATED: 'Mission Created',
      MISSION_UPDATED: 'Mission Updated',
      MISSION_STATUS_UPDATED: 'Mission Status',
      MISSION_SPLIT: 'Mission Split',
      MISSION_DELETED: 'Mission Deleted',
      COMMENT_CREATED: 'Comment Created',
      TRANSPORT_CREATED: 'Transport Created',
      TRANSPORT_COMPLETED: 'Transport Completed',
      SELECTION_STARTED: 'Selection Started',
      SELECTION_ENDED: 'Selection Ended',
      FILE_UPLOADED: 'File Uploaded',
      PATIENT_IDS_UPDATED: 'Patient IDs Updated',
      SCHEDULE_CREATED: 'Schedule Created',
      BOOKING_CREATED: 'Booking Created',
      EXERCISE_DAY_ACTIVATED: 'Day Activated',
      EXERCISE_DAY_RESET: 'Day Reset',
      SETTING_UPDATED: 'Setting Updated',
      PATIENTS_IMPORTED: 'Patients Imported',
      PATIENTS_EXCLUDED: 'Patients Excluded',
      PATIENTS_ADDED: 'Patients Added',
      REQUEST_DELETED: 'Request Deleted',
      REQUEST_REVERTED_TO_DRAFT: 'Reverted to Draft',
    },
    transportMode: {
      SEATED: 'Seated',
      LYING: 'Lying',
      TBA: 'TBA',
    },
    dependency: {
      LOW: 'Low',
      MEDIUM: 'Medium',
      HIGH: 'High',
      TBA: 'TBA',
    },
  },

  // ============================================================
  // HEALTH DASHBOARD
  // ============================================================
  healthDashboard: {
    title: 'System Health Dashboard',
    unableToLoad: 'Unable to Load Health Data',
    retry: 'Retry',
    refresh: 'Refresh',
    refreshFailed: 'Refresh failed',
    auto: 'Auto',
    manual: 'Manual',
    disableAutoRefresh: 'Disable auto-refresh',
    enableAutoRefresh: 'Enable auto-refresh (30s)',
    systemOverview: 'System Overview',
    uptime: 'Uptime',
    memory: 'Memory',
    dbLatency: 'DB Latency',
    serverTime: 'Server Time',
    activityToday: 'Activity Today',
    activeNations: 'Active Nations',
    requestsCreated: 'Requests Created',
    patients: 'Patients',
    missionsCreated: 'Missions Created',
    servicesStatus: 'Services Status',
    requestPipeline: 'Request Pipeline',
    noRequests: 'No requests',
    staleDrafts: 'Stale drafts (>24h)',
    reviewBottleneck: 'Review bottleneck (>48h)',
    publishedNoOffers: 'Published with no offers',
    dataConsistency: 'Data Consistency Checks',
    overallStatus: 'Overall Status',
    healthy: 'Healthy',
    warnings: 'Warnings',
    critical: 'Critical',
    check: 'Check',
    issues: 'Issues',
    noConsistencyChecks: 'No consistency checks available',
    databaseRecords: 'Database Records',
    exerciseStatus: 'Exercise Status',
    activeDay: 'Active Day',
    noActiveDay: 'No active day',
    templates: 'Templates',
    lastActivation: 'Last Activation',
    never: 'Never',
    recentAuditLog: 'Recent Audit Log',
    last10: 'Last 10',
    timestamp: 'Timestamp',
    user: 'User',
    action: 'Action',
    resource: 'Resource',
    noRecentAudit: 'No recent audit entries',
    justNow: 'just now',
    services: {
      database: 'Database',
      email: 'Email',
      sync: 'Sync',
      notifications: 'Notifications',
      maintenanceMode: 'Maintenance Mode',
      trainingMode: 'Training Mode',
      connectionFailed: 'Connection failed',
      enabledSmtp: 'Enabled & SMTP configured',
      enabledNoSmtp: 'Enabled but NO SMTP',
      disabled: 'Disabled',
      staleUnread: '{{count}} stale unread (>7d)',
      active: 'ACTIVE',
      off: 'Off',
    },
  },

  // ============================================================
  // PASSWORD COMPLEXITY
  // ============================================================
  passwordComplexity: {
    minLength: 'Bent 10 simbolių',
    uppercase: '1 didžioji raidė',
    lowercase: '1 mažoji raidė',
    digit: '1 skaitmuo',
    special: '1 specialus simbolis',
  },
};

export default lt;
